import _merge from 'lodash/merge';
import { Lightning } from '@lightningjs/sdk';
import { ICON_COLLECTION } from '@tornado-rdk/icons';
import Icon from '../../../../tornado/icon/icon.component';
import {
  getInitialStyle,
  defaultContext,
  ICON_SIZE,
  getFocusedStyle,
  getUnFocusedStyle,
  HEIGHT,
  ICON_MARGIN_RIGHT,
  SPACER_END,
} from './topBarItem.style';

export class TopBarItem extends Lightning.Component {
  static _template() {
    return _merge(
      {
        Background: {
          shader: {
            type: Lightning.shaders.RoundedRectangle,
          },
        },
        IconWrapper: {
          IconBackground: {
            shader: {
              type: Lightning.shaders.RoundedRectangle,
            },
          },
          Icon: {
            type: Icon,
          },
        },
        Label: {},
      },
      getInitialStyle(),
    );
  }

  _construct() {
    this._style = defaultContext;
  }

  _detach() {
    this.tag('Label').removeAllListeners('txLoaded');
  }

  set data(value) {
    const { text, icon } = value;

    const { screenSize } = this._style;

    this.tag('Label').once('txLoaded', () => {
      this.tag('Background').w =
        HEIGHT[screenSize] + ICON_MARGIN_RIGHT[screenSize] + this.tag('Label').finalW + SPACER_END[screenSize];
    });

    this.patch({
      IconWrapper: {
        Icon: {
          iconData: {
            viewBox: {
              h: ICON_SIZE[this._style.screenSize],
            },
            picto: {
              name: icon,
              collection: ICON_COLLECTION.SPECIAL,
            },
          },
        },
      },
      Label: {
        text: { text },
      },
    });
  }

  _focus() {
    this.patch(getFocusedStyle(this._style));
  }

  _unfocus() {
    this.patch(getUnFocusedStyle(this._style));
  }
}
